"use client";

import "../globals.css";
import { usePathname } from "next/navigation";
import HeaderGlob from "../componentsGLob/HeaderGlob";
import NavbarGlob from "../componentsGLob/NavBarGlob";
import Footer from "../componentsGLob/FooterGlob";

const coworkingNav = [
  { translationKey: "home", href: "#home" },
  { translationKey: "spazi", href: "#spazi" },
  { translationKey: "pricing", href: "#pricing" },
  { translationKey: "info", href: "#info" },
];

const buzzCardNav = [
  { translationKey: "piani", href: "#piani" },
  { translationKey: "punti", href: "#punti" },
  { translationKey: "eventi", href: "#eventi" },
  { translationKey: "partners", href: "#partners" },
];

export default function CowoLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const pathWithoutLang = pathname.replace(/^\/(en|it)/, "");
  const isBuzzCardPage = pathWithoutLang.startsWith("/coworking/buzz-card");
  const navItems = isBuzzCardPage ? buzzCardNav : coworkingNav;

  return (
    <div className="flex flex-col h-full">
      <HeaderGlob className="h-0 xl:h-auto" />

      <main className="bg-white xl:rounded-t-[80px]">
        <NavbarGlob navItems={navItems} />
        {children}
        <Footer />
      </main>
    </div>
  );
}
